"use client"

import { usePermission } from '@/lib/rbac/PermissionContext'
import { ReactNode } from "react"

type Props = {
  permission: string
  children: ReactNode
  fallback?: ReactNode
}

export default function Permission({
                                     permission,
                                     children,
                                     fallback = null
                                   }: Props) {

  const { has } = usePermission()

  if (!has(permission)) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
